import { render, staticRenderFns } from "./fila-exame.vue?vue&type=template&id=1583dba8&scoped=true&"
import script from "./fila-exame.vue?vue&type=script&lang=js&"
export * from "./fila-exame.vue?vue&type=script&lang=js&"
import style0 from "./fila-exame.vue?vue&type=style&index=0&id=1583dba8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1583dba8",
  null
  
)

export default component.exports